export default "__VITE_ASSET__ow4gnwgi__"